/**
 * Strips any non-numeric characters from a string.
 * Helpful for removing a text mask from a phone number (for example)
 */
export function stripNonNumericCharacters(value: string) {
  return value.replace(/[^0-9]/gi, "");
}
